import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainSummaryQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainSummaryQuery = { __typename?: 'Query', domainSummary: { __typename?: 'DomainSummary', name: string, description: string, shortNumbersLength: string, users: number, faxes: number, gateways: number, pickupGroups: number, callGroups: number, callQueues: number, ivrs: number } };


export const DomainSummaryDocument = gql`
    query DomainSummary($domainId: Int!) {
  domainSummary(domainId: $domainId) {
    name
    description
    shortNumbersLength
    users
    faxes
    gateways
    pickupGroups
    callGroups
    callQueues
    ivrs
  }
}
    `;

/**
 * __useDomainSummaryQuery__
 *
 * To run a query within a React component, call `useDomainSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainSummaryQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainSummaryQuery(baseOptions: Apollo.QueryHookOptions<DomainSummaryQuery, DomainSummaryQueryVariables> & ({ variables: DomainSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainSummaryQuery, DomainSummaryQueryVariables>(DomainSummaryDocument, options);
      }
export function useDomainSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainSummaryQuery, DomainSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainSummaryQuery, DomainSummaryQueryVariables>(DomainSummaryDocument, options);
        }
export function useDomainSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainSummaryQuery, DomainSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainSummaryQuery, DomainSummaryQueryVariables>(DomainSummaryDocument, options);
        }
export type DomainSummaryQueryHookResult = ReturnType<typeof useDomainSummaryQuery>;
export type DomainSummaryLazyQueryHookResult = ReturnType<typeof useDomainSummaryLazyQuery>;
export type DomainSummarySuspenseQueryHookResult = ReturnType<typeof useDomainSummarySuspenseQuery>;
export type DomainSummaryQueryResult = Apollo.QueryResult<DomainSummaryQuery, DomainSummaryQueryVariables>;